import { languageSelector } from "@/src/contexts";
import { usePageContext } from "@/src/contexts/PageContext";
import Container from "@Components/Container";
import type { IImageLoader } from "@Components/ImageLoader";
import ImageLoader from "@Components/ImageLoader";
import type { QuerySmMax, QueryXsMax } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import Share from "../common/Share";

import * as cssPortal from "../shared/Portal.module.css";
import * as css from "./MomentHeader.module.css";

export interface IMomentHeader {
    image: IImageLoader;
    title: string;
    description: string;
    descriptionFormatted: string;
}

export const MomentHeader = (props: IMomentHeader) => {
    const { pageTitle, canonicalUrl } = usePageContext();
    const shareText = languageSelector(
        `Sprawdź tę okazję na goodie: ${pageTitle}`,
        `Check out this offer on goodie: ${pageTitle}`,
    );

    return (
        <div className={css.momentHeaderComponent}>
            <Share
                shareUrl={canonicalUrl}
                title={`Goodie - ${pageTitle}`}
                text={shareText}
                className={cssPortal.standardContainer}
                buttonStyleX={styles.button}
                iconStyleX={styles.shareIcon}
            />
            <ImageLoader {...props.image} />
            <Container>
                <h1>{props.title}</h1>
                <div className={css.description}>
                    {props.descriptionFormatted != null ? (
                        <div dangerouslySetInnerHTML={{ __html: props.descriptionFormatted }} />
                    ) : (
                        props.description
                    )}
                </div>
            </Container>
        </div>
    );
};

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const smMax: QuerySmMax = "@media (max-width: 989px)";

const styles = stylex.create({
    button: {
        position: "absolute",
        right: {
            default: 0,
            [smMax]: 20,
        },
        top: 20,
    },

    shareIcon: {
        verticalAlign: "middle",
        height: { default: 35, [xsMax]: 22 },
        width: { default: 35, [xsMax]: 22 },
    },
});
